import React from 'react';
import { Box, Button, ListItemText, Typography } from '@mui/material';
import { useAppDispatch } from '../../../../hooks';
import { closeMobileMenu } from './menuSlice';
import useTranslations from '../../../global/translation/hooks/translation';
import { scrollFn } from '../helper';
import { useThemeContext } from '../../../global/ThemeContext';
import { setLanguage } from '../../../global/translation/translationSlice';
import DarkModeToggle from '../../DarkModeToggle';
import { designTokens } from '../../../../theme/designTokens';

const MobileMenuLinks = () => {
  const { currentLanguage, translations } = useTranslations();
  const dispatch = useAppDispatch();
  const { darkMode } = useThemeContext();
  const palette = darkMode ? designTokens.colors.dark : designTokens.colors.light;
  const navColor = palette.text.primary;
  const navButtonSx = { textTransform: 'none', py: 1.1 };

  const handleCloseNavMenu = () => {
    dispatch(closeMobileMenu());
  };

  const handleMobileLinkClick = (e: React.MouseEvent<HTMLButtonElement>, section: string) => {
    scrollFn(section);
    setTimeout(() => {
      handleCloseNavMenu();
    }, 1000);
  };

  return (
    <>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'about')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: navColor }}>{translations.menuItems.aboutUs[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'abeo')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: palette.primary, fontWeight: 800 }}>
              {translations.menuItems.abeo[currentLanguage]}
            </Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'offer')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: navColor }}>{translations.menuItems.offer[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'horses')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: navColor }}>{translations.menuItems.horses[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'method')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: navColor }}>{translations.menuItems.method[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'pricing')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: navColor }}>{translations.menuItems.pricing[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'team')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: navColor }}>{translations.menuItems.ourTeam[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'contact')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: navColor }}>{translations.menuItems.contact[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: '0 0 auto', justifyContent: 'center' }}>
        <DarkModeToggle />
        <Button
          onClick={() => {
            currentLanguage === 'en' ? dispatch(setLanguage('pl')) : dispatch(setLanguage('en'));
          }}
          size="large"
          sx={{ minWidth: 0, px: 2, ml: 1, fontWeight: 700, color: navColor, textTransform: 'none', justifyContent: 'left' }}
        >
          {currentLanguage === 'en' ? 'PL' : 'EN'}
        </Button>
      </Box>
    </>
  );
};

export default MobileMenuLinks;
